// stack-qty.js
// Safe quantity multiplier + height-note refresher + non-invasive ATC label update
// Overwrite your existing stack-qty.js with this file.

(function () {
  'use strict';

  /* ------------------------ Helpers ------------------------ */

  function safeParseInt(v, fallback) {
    var n = parseInt(v, 10);
    return Number.isFinite(n) && n > 0 ? n : fallback;
  }

  function readSelectedVariantJSON() {
    try {
      var el = document.querySelector('[data-selected-variant], script[data-selected-variant]');
      if (!el) return null;
      var txt = el.textContent || el.innerText;
      if (!txt) return null;
      return JSON.parse(txt);
    } catch (e) {
      return null;
    }
  }

  function getProductIdFromForm(form) {
    if (!form) return null;
    var input = form.querySelector('input[name="product-id"]');
    if (input && input.value) return String(input.value);
    var wrapper = form.closest ? form.closest('[data-product-id]') : null;
    if (wrapper) return wrapper.getAttribute('data-product-id');
    try {
      if (window.stackQtyMap && typeof window.stackQtyMap === 'object') {
        var keys = Object.keys(window.stackQtyMap);
        if (keys.length === 1) return String(keys[0]);
      }
    } catch (e) {}
    return null;
  }

  function getVariantIdFromForm(form) {
    if (!form) return null;
    var idInput = form.querySelector('input[name="id"]');
    if (idInput && idInput.value) return String(idInput.value);
    var terms = form.querySelector('shopify-payment-terms[variant-id]');
    if (terms) {
      var v = terms.getAttribute('variant-id');
      if (v) return String(v);
    }
    var sel = readSelectedVariantJSON();
    if (sel && sel.id) return String(sel.id);
    return null;
  }

  function getStackQty(productId, variantId) {
    try {
      if (!productId || !variantId) return 1;
      var map = window.stackQtyMap && window.stackQtyMap[String(productId)];
      if (!map) return 1;
      var raw = map[String(variantId)];
      if (raw === undefined || raw === null) return 1;
      var n = parseInt(raw, 10);
      return Number.isFinite(n) && n > 0 ? n : 1;
    } catch (e) {
      return 1;
    }
  }

  function getSetsQty(form) {
    try {
      if (!form) return 1;
      var qtyInput = form.querySelector('input[name="quantity"]');
      var v = qtyInput && qtyInput.value ? qtyInput.value : '1';
      return safeParseInt(v, 1);
    } catch (e) {
      return 1;
    }
  }

  /* ------------------------ Height note updater ------------------------ */

  function updateHeightNote(form) {
    try {
      var productId = getProductIdFromForm(form);
      var variantId = getVariantIdFromForm(form);
      if (!productId || !variantId) {
        var anyForm = document.querySelector('form[action*="/cart/add"]');
        if (anyForm) {
          productId = productId || getProductIdFromForm(anyForm);
          variantId = variantId || getVariantIdFromForm(anyForm);
        }
      }
      if (!productId || !variantId) return;

      var stack = getStackQty(productId, variantId) || 1;

      var noteEl = (form && form.closest) ? form.closest('[data-product-id]')?.querySelector('[data-stack-height-note]') : null;
      if (!noteEl) noteEl = document.querySelector('[data-stack-height-note]');
      if (!noteEl) return;

      var text = stack === 1 ? 'Includes 1 stackable bed.' : 'Includes ' + stack + ' stackable beds (stacked).';
      if (noteEl.textContent !== text) noteEl.textContent = text;
    } catch (e) {}
  }

  /* ------------------------ Multiply quantity on submit ------------------------ */

  document.addEventListener('submit', function (evt) {
    try {
      var form = evt.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.action || form.action.indexOf('/cart/add') === -1) return;

      var productId = getProductIdFromForm(form);
      var variantId = getVariantIdFromForm(form);
      var qtyInput = form.querySelector('input[name="quantity"]');

      if (!productId || !variantId || !qtyInput) return;

      var sets = getSetsQty(form);
      var stack = getStackQty(productId, variantId);
      var finalQty = Number(sets) * Number(stack);
      if (!Number.isFinite(finalQty) || finalQty < 1) finalQty = 1;

      qtyInput.value = String(finalQty);
    } catch (e) {
      return;
    }
  }, true);

  /* ------------------------ Add-to-cart button label updater ------------------------ */

  function formatMoneyCentsWithSample(cents) {
    var num = Number(cents) / 100;
    try {
      var cc = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
      if (cc) {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: cc }).format(num);
      }
    } catch (e) {}
    var sample = document.querySelector('[data-product-price], .product__price, .price, .price--regular, .f-price');
    if (sample) {
      var sampleText = sample.textContent.trim();
      var suffixMatch = sampleText.match(/\b([A-Z]{2,4})\b\s*$/);
      if (suffixMatch) return num.toFixed(2) + ' ' + suffixMatch[1];
      var symbolPrefix = sampleText.replace(/[\d\s.,\-"]/g, '').trim();
      if (symbolPrefix) return symbolPrefix + num.toFixed(2);
    }
    return num.toFixed(2);
  }

  function updateAddToCartLabel(form) {
    try {
      if (!form) form = document.querySelector('form[action*="/cart/add"]');
      if (!form) return;

      // get selected variant price
      var sel = readSelectedVariantJSON();
      if (!sel || typeof sel.price === 'undefined') {
        // fallback: try to read from product JSON script + id input
        var prodJsonEl = document.querySelector('script[type="application/json"][data-product-json]');
        var idVal = form.querySelector('input[name="id"]') ? form.querySelector('input[name="id"]').value : null;
        if (prodJsonEl && idVal) {
          try {
            var p = JSON.parse(prodJsonEl.textContent);
            if (p && p.variants) {
              for (var i = 0; i < p.variants.length; i++) {
                if (String(p.variants[i].id) === String(idVal)) { sel = p.variants[i]; break; }
              }
            }
          } catch (e) { sel = null; }
        }
      }
      if (!sel || typeof sel.price === 'undefined') return;

      var productId = getProductIdFromForm(form);
      var variantId = getVariantIdFromForm(form);
      var sets = getSetsQty(form);
      var stack = getStackQty(productId, variantId) || 1;
      var finalQty = Number(sets) * Number(stack);
      if (!Number.isFinite(finalQty) || finalQty < 1) finalQty = 1;

      var unitCents = Number(sel.price);
      var totalCents = unitCents * finalQty;
      var formatted = formatMoneyCentsWithSample(totalCents);

      // find button
      var btn = form.querySelector('button[type="submit"], button.add-to-cart, [data-add-to-cart]') || document.querySelector('button[type="submit"]');
      if (!btn) return;

      // store original label
      if (!btn.dataset.originalLabel) {
        var inner = btn.querySelector('span, .button__text');
        var txt = inner ? inner.textContent.trim() : (btn.textContent || '').trim();
        btn.dataset.originalLabel = txt || 'Add to cart';
      }
      var orig = btn.dataset.originalLabel;

      var newLabel = orig + ' — ' + formatted;
      var innerSpan = btn.querySelector('span, .button__text');
      if (innerSpan) innerSpan.textContent = newLabel; else btn.textContent = newLabel;
      btn.setAttribute('aria-label', newLabel);
      btn.dataset.multipliedQty = String(finalQty);
    } catch (e) {
      // fail silently
    }
  }

  /* ------------------------ Lightweight observer: reapply note & ATC label ------------------------ */

  (function keepNoteAndLabelAlive() {
    if (typeof document === 'undefined') return;

    var scheduled = new WeakMap();

    function debouncedRefresh(form, delay) {
      if (!form) return;
      var existing = scheduled.get(form);
      if (existing) clearTimeout(existing);
      var id = setTimeout(function () {
        scheduled.delete(form);
        try {
          updateHeightNote(form);
          updateAddToCartLabel(form);
        } catch (e) {}
      }, delay || 80);
      scheduled.set(form, id);
    }

    function observeForm(form) {
      if (!form || form._stackNoteObserved) return;
      form._stackNoteObserved = true;
      try {
        var mo = new MutationObserver(function (muts) {
          for (var i = 0; i < muts.length; i++) {
            var m = muts[i];
            if (m.type === 'childList') {
              if (m.addedNodes.length || m.removedNodes.length) { debouncedRefresh(form, 90); return; }
            }
            if (m.type === 'attributes' && (m.attributeName === 'class' || m.attributeName === 'style')) { debouncedRefresh(form, 90); return; }
          }
        });
        mo.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
      } catch (e) {}
    }

    function attach() {
      try {
        var forms = document.querySelectorAll('form[action*="/cart/add"]');
        for (var i = 0; i < forms.length; i++) observeForm(forms[i]);
      } catch (e) {}
    }

    attach();
    setTimeout(attach, 250);

    try {
      var docMo = new MutationObserver(function (muts) {
        var saw = false;
        for (var i = 0; i < muts.length; i++) if (muts[i].addedNodes && muts[i].addedNodes.length) { saw = true; break; }
        if (saw) attach();
      });
      docMo.observe(document.documentElement || document, { childList: true, subtree: true });
    } catch (e) {}
  })();

  /* ------------------------ Initial run on DOM ready ------------------------ */

  try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        var forms = document.querySelectorAll('form[action*="/cart/add"]');
        for (var i = 0; i < forms.length; i++) {
          updateHeightNote(forms[i]);
          updateAddToCartLabel(forms[i]);
        }
        updateHeightNote(document.querySelector('form[action*="/cart/add"]') || null);
        updateAddToCartLabel(document.querySelector('form[action*="/cart/add"]') || null);
      });
    } else {
      var formsNow = document.querySelectorAll('form[action*="/cart/add"]');
      for (var j = 0; j < formsNow.length; j++) {
        updateHeightNote(formsNow[j]);
        updateAddToCartLabel(formsNow[j]);
      }
      updateHeightNote(document.querySelector('form[action*="/cart/add"]') || null);
      updateAddToCartLabel(document.querySelector('form[action*="/cart/add"]') || null);
    }
  } catch (e) {}

})();